import React, { useState, useEffect, createRef } from "react";
import _ from "underscore";
import "../../assets/css/comment.css";
import { InitalRender, originalValues, rollsWidget } from "./../common/Helper";
import HtmlInputEditorShow from "../common/HtmlInputEditorShow";
import {
  EditorState,
  convertFromRaw,
  convertToRaw,
  ContentState,
  Modifier,
  Entity,
  CompositeDecorator,
} from "draft-js";
import HtmlInputEditorShowComment from "../common/HtmlInputEditorShowComment";
import { getRandomInt } from "../../utils/commonFunction";
import Swal from "sweetalert2";
import { FilePond, File, registerPlugin, setOptions } from "react-filepond";
import "filepond/dist/filepond.min.css";
import { useSelector } from "react-redux";
import UserHover from "../common/UserHover";
import moment from "moment";
import Str from "../common/Str";
import ThumbsUpIcon from '../../assets/images/Thumbsup.png'
import ThumbsDownIcon from '../../assets/images/ThumbsDown.png'
import RedHeartIcon from '../../assets/images/RedHeart.png'
import PoutingIcon from '../../assets/images/Pouting.png'
import OpenFaceIcon from '../../assets/images/OpenFace.png'
import GrinningIcon from '../../assets/images/GrinningFace.png'
import FrowningIcon from '../../assets/images/Frowning.png'
import UnknownStudent from "../../assets/images/ic_unknown_user.png"
import UnknownStudentStatus from "../../assets/images/ic_unknown_user_online_status.png"
import HtmlParser from "react-html-parser";
import { readCommentMessages } from "../../services/QualificationService";


const FeedComments = (props) => {
  const [showReply, setShowReply] = useState(false);
  const [data, setData] = useState([]);
  const [copyText, setCopyText] = useState(0);
  const [resStr, setResStr] = useState("");
  const [newStr, setNewStr] = useState("");
  const [unreadMsg, setUnreadMsg] = useState("");
  const [globalMention, setGlobalMention] = useState(false);
  const [globalImportant, setGlobalImportant] = useState(false);
  const [globalAttachment, setGlobalAttachment] = useState(false);
  const [globalMentionComment, setGlobalMentionComment] = useState(false);
  const [globalImportantComment, setGlobalImportantComment] = useState(false);
  const [globalAttachmentComment, setGlobalAttachmentComment] = useState(false);
  const [actionState, setActionState] = useState(0);
  const [editableArr, setEditableArr] = useState([]);
  const [importantArr, setImportantArr] = useState([{}]);
  const [editableAllArr, setEditableAllArr] = useState([]);
  const [users, setUsers] = useState(props.userData);
  const [newComments, setNewComments] = useState(0);
  const [reduceReq, setReduceReq] = useState(true);
  const [showNewTag, setShowNewTag] = useState(false);
  const [team, setTeam] = useState([]);
  const [userRole, setUserRole] = useState("");

  const user = useSelector((state) => state.user);

  const HandleSpan = (props) => {
    return (
      <span style={styles.handle} data-offset-key={props.offsetKey}>
        {props.children}
      </span>
    );
  };

  

  function handleStrategy(contentBlock, callback, contentState) {
    findWithRegex(HANDLE_REGEX, contentBlock, callback);
  }

  const compositeDecorator = new CompositeDecorator([
    { strategy: handleStrategy, component: HandleSpan },
  ]);
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty(compositeDecorator)
  );

  useEffect(() => {
    globalIconHandle(data);
  }, [data]);

  function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const HANDLE_REGEX = /\@[\w]+/g;
  const styles = {
    editor: {
      border: "1px solid #ddd",
      cursor: "text",
      fontSize: 16,
      minHeight: "40px",
      padding: 10,
      background: "#000",
    },
    handle: {
      color: "rgba(98, 177, 254, 1.0)",
      direction: "ltr",
      unicodeBidi: "bidi-override",
    },
  };

  // Regex used to identify @mentions inside comment text
  function findWithRegex(regex, contentBlock, callback) {
    const text = contentBlock.getText();
    let matchArr, start;
    while ((matchArr = regex.exec(text)) !== null) {
      start = matchArr.index;
      callback(start, start + matchArr[0]?.length);
    }
  }

  useEffect(() => {
    props.childFun.current = readComment;
  });

  useEffect(() => {
    if (!props.comments || (Array.isArray(props.comments) && props.comments.length === 0)) {
      setData([]);
      return;
    }
    setData(normalizeCommentUsers(props.comments));
    let finalStr = "";
    let usersArr = [];
    let commentsCount = props.comments?.length;
    let newCount = 0;
    let allNewCount = 0;
    if (props.comments) {
      props.comments.map((commentItem) => {
        usersArr.push(
          commentItem && commentItem.user && commentItem.user.fullname ? commentItem.user.fullname : " "
        );
        if (commentsCount === 1 && !props?.readMessages?.comment_id) {
          readComment(commentItem.message_id, commentItem.id);
        }
        if (props?.readMessages?.comment_id < commentItem.id) {
          if (commentItem.user_id !== user.id) {
            newCount += 1;
          }
          allNewCount += 1;
          setShowNewTag(true);
        }
        setNewComments(newCount > 0 ? newCount - 1 : 0);
      });
    }

    const uniqueUsersSet = new Set(usersArr);
    if (Number(uniqueUsersSet.size) === 1) {
      finalStr =
        usersArr.length -
        1 +
        (usersArr.length === 1 ? " reply" : " replies") +
        " from " +
        usersArr[0];
    } else if (Number(uniqueUsersSet.size) === 2) {
      let uniqueUsersArr = Array.from(uniqueUsersSet);
      let tempUsers = uniqueUsersArr[0] + " and " + uniqueUsersArr[1];
      finalStr = usersArr.length - 1 + " replies from " + tempUsers;
    } else if (uniqueUsersSet.size > 2) {
      let uniqueUsersArr = Array.from(uniqueUsersSet);
      let tempUsers = uniqueUsersArr[0];
      finalStr =
        usersArr.length -
        1 +
        " replies from " +
        tempUsers +
        " + " +
        " others ";
    }
    setResStr(
      usersArr.length > 0 
      ? finalStr
      : ""
    );
    setUnreadMsg(newCount > 1 ? true : false);
    if (
      (Number(newCount) === 1 && props.comments.length > 0) ||
      (allNewCount > 0 &&
        props.comments[props.comments.length - 1].user_id == user.id)
    ) {
      readComment(
        props.comments[props.comments.length - 1].message_id,
        props.comments[props.comments.length - 1].id
      );
    }
  }, [props.comments, actionState]);

  useEffect(() => {
    let mounted = true
    if (props.teamObj) {
      let commentsWithRoles = props.comments.map((commentItem) => {
        let matchedAdminRole = props.teamObj.find(teamMember => {
          return Number(teamMember.id) === Number(commentItem.admin_id)
        })
        if ([null, undefined].includes(commentItem.admin_id)) {
          matchedAdminRole = { role: "student" }
        }
        else if (!matchedAdminRole) {
          matchedAdminRole = { role: commentItem?.adminuser?.job_title }
        }
        return { ...commentItem, roleKey: matchedAdminRole.role }
      })
      setData(normalizeCommentUsers(commentsWithRoles));
    }

    return function cleanup() {
      mounted = false
    }
  },[props.comments,actionState])

  // Shuffle comments and attach admin user if user is missing
  const normalizeCommentUsers = (commentList) => {
    commentList.map((commentItem, commentIndex) => {
      if (!commentItem.user) commentList[commentIndex].user = commentItem.adminuser;
    });
    return commentList;
  };

  /**
   * Mark comment messages as read
   * @param {string} messageId
   * @param {string} commentId
  */
  const readComment = (messageId, commentId) => {
    readCommentMessages({ message_id: messageId, comment_id: commentId })
      .catch((error) => {
        console.error("FeedComments > readComment : Error while reading comment:", error);
      });
  };

  const expandComList = () => {
    let allCommentsData = data;
    let isUnreadMsg = false;
    let reduceCount = 0;
    allCommentsData.map((commentItem) => {
      if (
        !props?.readMessages?.comment_id ||
        commentItem.id > props?.readMessages?.comment_id
      ) {
        isUnreadMsg = true;
        reduceCount += 1;
      }
    });
    if (isUnreadMsg) {
      let msg_id = allCommentsData[0].message_id;
      let comment_id = allCommentsData[allCommentsData.length - 1].id;
      readComment(msg_id, comment_id);
      if (reduceReq) {
        props.reduceCount(reduceCount, props.room_id);
        setReduceReq(false);
      }
      setActionState(getRandomInt(5000));
    }
  };


  const userTagColor = (comment_user, login_user) => {
    if (comment_user == login_user) {
      return " my-tag ";
    } else {
      return " other-tag ";
    }
  };

  const showTagIcon = (
    commentText,
    commentUserId,
    loggedInUserId,
    loggedInUser,
    commentItem,
    commentIndex
  ) => {
    if (commentText?.includes(`@${loggedInUser.fullname}`)) {
      if (commentIndex < data.length - 1) {
        if (!globalMention) {
          setGlobalMention(true);
        }
      } else {
        if (!globalMentionComment) {
          setGlobalMentionComment(true);
        }
      }
      return " post-reaction-icon ";
    } else {
      return "";
    }
  };


  // Check whether user liked or not
  const isLiked = (loggedInUserId, likedUsers) => {
    if (likedUsers.length) {
      for (let userIndex = 0; userIndex < likedUsers.length; userIndex++) {
        if (likedUsers[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user disliked or not
  const isDisliked = (loggedInUserId, dislikedUsers) => {
    if (dislikedUsers.length) {
      for (let userIndex = 0; userIndex < dislikedUsers.length; userIndex++) {
        if (dislikedUsers[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user has loved the comment
  const isLoved = (loggedInUserId, loveUsers) => {
    if (loveUsers.length) {
      for (let userIndex = 0; userIndex < loveUsers.length; userIndex++) {
        if (loveUsers[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user reacted with laugh
  const isLaughed = (loggedInUserId, laughUsers) => {
    if (laughUsers.length) {
      for (let userIndex = 0; userIndex < laughUsers.length; userIndex++) {
        if (laughUsers[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user reacted with surprise
  const isSurprised = (loggedInUserId, surpriseUsers) => {
    if (surpriseUsers.length) {
      for (let userIndex = 0; userIndex < surpriseUsers.length; userIndex++) {
        if (surpriseUsers[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user reacted with sad
  const isSad = (loggedInUserId, sadArr) => {
    if (sadArr.length) {
      for (let userIndex = 0; userIndex < sadArr.length; userIndex++) {
        if (sadArr[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Check whether user reacted with angry
  const isAngry = (loggedInUserId, angryArr) => {
    if (angryArr.length) {
      for (let userIndex = 0; userIndex < angryArr.length; userIndex++) {
        if (angryArr[userIndex].user_id == loggedInUserId) {
          return true;
        }
      }
    }
    return false;
  };

  // Render users who reacted on comment
  const renderActionList = (usersArr = [], position) => {
    return usersArr.map((reactionUser, userIndex) => {
      if (!reactionUser.user) {
        usersArr[userIndex].user = reactionUser.adminuser;
        usersArr[userIndex].user_id = reactionUser?.adminuser?.UserID;
        usersArr[userIndex].userType = "admin";
      }
      return (
        <li key={userIndex}>
          <div className="user-drop-down-img online-status card-left assigned-title-blk">
            {reactionUser?.user ? 
            <>
              {reactionUser?.user?.photo == null ? (
                reactionUser?.user?.fullname ? InitalRender(reactionUser?.user?.fullname) : ""
              ) : (
                <img src={reactionUser?.user?.photo} />
              )}
              <span
                className={`portal-status-icon ${
                  reactionUser.user?.activity_status ? (reactionUser.user?.activity_status?.toLowerCase() == "online"
                    ? "online-u"
                    : reactionUser.user?.activity_status?.toLowerCase() == "donotdisturb"
                    ? "donotdisturb-u"
                    : "offline-u") : "offline-u"
                }`}
              >
                {" "}
              </span>
            </>
            :<>
            <img src={UnknownStudent} alt="unknown" />
            <span className="portal-status-icon border-0">
              <img src={UnknownStudentStatus} alt="unknown" />    
            </span>
            </>}

            <UserHover
              directionCls={"popup-top"}
              user={reactionUser.user}
              hideEmail={true}
              online={`portal-status-icon ${
                reactionUser.user?.activity_status?.toLowerCase() == "online"
                  ? "online-u"
                  : reactionUser.user?.activity_status?.toLowerCase() == "donotdisturb"
                  ? "donotdisturb-u"
                  : "offline-u"
              }`}
            />
          </div>
          <div className="info-drop">
            <span title={reactionUser?.user?.first_name ? reactionUser?.user?.first_name : "Unknown User"}>{reactionUser?.user?.first_name ? reactionUser?.user?.first_name : "Unknown User"}</span>
            {reactionUser?.user ? 
            <a
              href="#!"
              title={`${
                isLiked(
                  reactionUser.user.id,
                  data[position] && data[position].likes
                    ? data[position].likes
                    : []
                )
                  ? "Like"
                  : isDisliked(
                      reactionUser.user.id,
                      data[position].dislikes ? data[position].dislikes : []
                    )
                  ? "Dislike"
                  : isLoved(
                      reactionUser.user.id,
                      data[position].love ? data[position].love : []
                    )
                  ? "Love"
                  : isLaughed(
                      reactionUser.user.id,
                      data[position].laugh ? data[position].laugh : []
                    )
                  ? "Laugh"
                  : isSurprised(
                      reactionUser.user.id,
                      data[position].surprised ? data[position].surprised : []
                    )
                  ? "Surprised"
                  : isSad(
                      reactionUser.user.id,
                      data[position].sad ? data[position].sad : []
                    )
                  ? "Sad"
                  : isAngry(
                      reactionUser.user.id,
                      data[position].angry ? data[position].angry : []
                    )
                  ? "Angry"
                  : "NA"
              }`}
            >              
              {
                  isLiked(reactionUser.user.id,
                    data[position] && data[position].likes ? data[position].likes : []
                  )
                    ? <img className="chat-reaction-icon" src={ThumbsUpIcon} alt="Like" />
                    : isDisliked(
                        reactionUser.user.id,
                        data[position].dislikes ? data[position].dislikes : []
                      )
                    ? <img className="chat-reaction-icon" src={ThumbsDownIcon} alt="Dislike" />
                    : isLoved(
                      reactionUser.user.id, 
                      data[position].love ? data[position].love : []
                    )
                    ? <img className="chat-reaction-icon" src={RedHeartIcon} alt="Love" />
                    : isLaughed(
                        reactionUser.user.id,
                        data[position].laugh ? data[position].laugh : []
                      )
                    ? <img className="chat-reaction-icon" src={GrinningIcon} alt="Laugh" />
                    : isSurprised(
                        reactionUser.user.id,
                        data[position].surprised ? data[position].surprised : []
                      )
                    ? <img className="chat-reaction-icon" src={OpenFaceIcon} alt="Surprised" />
                    : isSad(reactionUser.user.id, data[position].sad ? data[position].sad : [])
                    ? <img className="chat-reaction-icon" src={FrowningIcon} alt="Sad" />
                    : isAngry(
                        reactionUser.user.id,
                        data[position].angry ? data[position].angry : []
                      )
                    ? <img className="chat-reaction-icon" src={PoutingIcon} alt="Angry" />
                    : null
                }
            </a>
                 : null}
          </div>
        </li>
      );
    });
  };

  // Delete comment confirmation popup
  const deleteConfirm = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete comment!",
    }).then((result) => {
      if (result.isConfirmed) {
        props.deleteHandle({
          comment_id: id,
          message_type: "deleted",
          message_id: null,
          table_type: "comment",
          deletedFiles: [],
        });
      }
    });
  };

  /**
   * Opens the selected comment in edit mode.
   *
   * @param {Object} commentItem - Comment data object
   * @param {string|number} commentItem.id - Unique comment identifier
   * @returns {void}
   */
  const editComment = (commentItem) => {
    setTimeout(() => {
      props.setShowHideEdit([commentItem.id]);
    }, 200);
  };

  /**
 * Remove selected editable comment id from edit state
 * @param {string} commentId
 */
  const removeEditableId = (commentId) => {
    props.setShowHideEdit(previousEditableIds =>
      previousEditableIds.filter(editableCommentId => editableCommentId !== commentId)
    );
  };

  const sendClickHandle = (
    messageValue,
    comment_id,
    attachments,
    sizes,
    message_id
  ) => {
    readComment(
      props.comments[props.comments.length - 1].message_id,
      props.comments[props.comments.length - 1].id
    );
    let tempImportant = false;
    let updatedCommentsData = data;
    let deletedFiles = [];
    let remainFiles = [];
    updatedCommentsData.map((commentItem) => {
      if (commentItem.id == comment_id) {
        commentItem.attachments.map((attachmentItem) => {
          if (attachmentItem.isDeleted) {
            deletedFiles.push(attachmentItem.attachment);
          } else {
            remainFiles.push(attachmentItem);
          }
        });
        tempImportant = commentItem.important;
        attachments = [
          ...remainFiles.map((remainingFile) => remainingFile.attachment),
          ...attachments
        ];
        deletedFiles = deletedFiles;
        sizes = [
          ...remainFiles.map((remainingFile) =>
            remainingFile.size ? remainingFile.size : "NA"
          ),
          ...sizes
        ];
      }
    });

    props.editHandle(
      messageValue,
      comment_id,
      tempImportant,
      attachments,
      sizes,
      deletedFiles,
      message_id
    );
    props.setShowHideEdit([]);
  };

  // Update important flag for selected comment
  const importantHandle = (commentData, value) => {
    let updatedImportantState = importantArr[0];
    updatedImportantState[commentData.id] = value;
    setImportantArr((pre) => [updatedImportantState]);

    let updatedCommentsData = data;
    updatedCommentsData.map((commentItem) => {
      if (commentItem.id == commentData.id) {
        commentItem.important = value;
      }
    });
    globalIconHandle(updatedCommentsData);

    setData(updatedCommentsData);
  };

  // Soft delete attachment from comment
  const deletedFileHandle = (id, path) => {
    let updatedCommentsData = data;
    updatedCommentsData.map((commentItem) => {
      if (commentItem.id == id) {
        commentItem.attachments.map((attachmentItem) => {
          if (path != attachmentItem.attachment) {
            if (!attachmentItem.isDeleted) {
              attachmentItem.isDeleted = false;
            }
          } else {
            attachmentItem.isDeleted = true;
          }
        });
      }
    });
    setData((pre) => [...updatedCommentsData]);
  };

  const globalIconHandle = (commentsData) => {
    let hasImportantComment = false;
    let hasAttachmentComment = false;
    let hasLatestImportantComment = false;
    let hasLatestAttachmentComment = false;

    commentsData.map((commentItem, commentIndex) => {
      if (commentIndex < commentsData.length - 1) {
        if (commentItem.important) {
          if (!hasImportantComment) {
            hasImportantComment = true;
          }
        }
        if (commentItem.attachments && commentItem.attachments.length) {
          if (!hasAttachmentComment) {
            hasAttachmentComment = true;
          }
        }
      } else {
        if (commentItem.important) {
          if (!hasLatestImportantComment) {
            hasLatestImportantComment = true;
          }
        }
        if (commentItem.attachments && commentItem.attachments.length) {
          if (!hasLatestAttachmentComment) {
            hasLatestAttachmentComment = true;
          }
        }
      }
    });
    setGlobalImportant(hasImportantComment);
    setGlobalAttachment(hasAttachmentComment);
    setGlobalImportantComment(hasLatestImportantComment);
    setGlobalAttachmentComment(hasLatestAttachmentComment);
  };

// Reset editor state when comment is not in edit mode
const handleReset = (commentItem) => {
  if (!props.showHideEditArr.includes(commentItem.id)) {
    props.resetEditor(true);
  }
};

  // Handle reply button click
  const handleReplyToComment = (replyCommentData) =>{
    props.showReplyEditor(replyCommentData);
  }

  return (
    <>
      <div
        className={
          "other-reply summary-main " +          
          (props.comments.length == 1 ? " hide-comment-cnt " : "")
        }
      >
        <div
          className="comment-con"
          onClick={() => {
            setShowReply(!showReply);
            expandComList();
          }}
        >
          <i
            className={
              "fal " +
              (showReply ? "fa-angle-double-up" : "fa-angle-double-down")
            }
          ></i>
          {showReply ? (
            "Collapse all"
          ) : (
            <div
              className={`comment-con ${
                newComments > 0 ? " new-reply-font" : ""
              }`}
            >
              {newComments > 0 ? <p className="new-cmt-txt"> New</p> : null}{" "}
              {resStr}
            </div>
          )}
        </div>
        {!showReply &&
        (globalImportant || globalMention || globalAttachment) ? (
          <div className="row_icons_fas ls_box">
            {globalImportant ? (
              <i
                className="fal fa-exclamation important-icon"
                title="Important"
              ></i>
            ) : null}
            {globalMention ? (
              <div className=" post-reaction-icon " title="Tag">
                <i className="fal fa-at"></i>
              </div>
            ) : null}
            {globalAttachment ? (
              <i
                className="fal fa-paperclip attachment-icon"
                title="Attachment"
              ></i>
            ) : null}
          </div>
        ) : null}
      </div>
      {data.map(function (commentItem, commentIndex) {
        if (commentIndex < data.length - 1) {
          if (commentItem.important) {
            if (!globalImportant) {
              if (props?.readMessages?.comment_id >= commentItem.id) {
                setGlobalImportant(true);
              }
            }
          }
          if (commentItem.attachments && commentItem.attachments.length) {
            if (!globalAttachment) {
              if (props?.readMessages?.comment_id >= commentItem.id) {
                setGlobalAttachment(true);
              }
            }
          }
        } else {
          if (commentItem.important) {
            if (!globalImportantComment) {
              if (props?.readMessages?.comment_id >= commentItem.id) {
                setGlobalImportantComment(true);
              }
            }
          }
          if (commentItem.attachments && commentItem.attachments.length) {
            if (!globalAttachmentComment) {
              if (props?.readMessages?.comment_id >= commentItem.id) {
                setGlobalAttachmentComment(true);
              }
            }
          }
        }
        const replyMessage = data.find(msg => msg.id == commentItem.reply_to);                

        return (
          <div
            className={"comment-box-block " + 
              (commentIndex < props.comments.length - 1 && !showReply
                ? " hide-reply"
                : " show-reply likeUnlikeBox")
            }
            key={commentIndex}
            onClick={() => {
              handleReset(commentItem);
            }}
          >
            {commentItem.reply_to > 0 ? 
            <a href={`#comment-message-${commentItem.reply_to}`} onClick={()=>{setShowReply(true);expandComList();}}>
              <div className="reply-to-card reply-show-card">
                <div className="reply-to-header">
                  <span className="reply-to-head-l">
                    <p className="reply-to-user">{replyMessage?.user && replyMessage?.user?.fullname ? replyMessage?.user?.fullname : "Unknown User"}</p>
                    <span>{moment(replyMessage?.created_at,"Do MMMM YYYY, h:mm:ss a").format("dddd, " + Str.TABLE_DATE_TIME_FORMAT)}</span>
                  </span>
                  <span className="reply-to-head-r">
                    {rollsWidget(replyMessage?.roleKey)}                      
                  </span>
                </div>
                <div className="reply-to-content">                    
                  {HtmlParser(replyMessage?.comment)}
                </div>
              </div>
            </a>
             : null}
            <div
              className={
                "card-reply  card-reply-box ps-by-card-header " +
                (commentItem.user_id === props.user.id ? " mycomment" : "")
                + (props?.readMessages?.comment_id && commentItem?.user?.id !== user.id && commentItem.id > props?.readMessages?.comment_id ? 
                  " new-feed-comment-highlight" : "")
              }
              id={`comment-message-${commentItem.id}`}
            >
              <div className="row_icons_fas ls_box desk-post-static">
                {commentItem.important ? (
                  <i
                    className="fal fa-exclamation important-icon"
                    title="Important"
                  ></i>
                ) : null}
                {showTagIcon(
                  commentItem.comment,
                  commentItem.user_id,
                  props.user.id,
                  props.user,
                  commentItem,
                  commentIndex
                ) != "" ? (
                  <div
                    className={showTagIcon(
                      commentItem.comment,
                      commentItem.user_id,
                      props.user.id,
                      props.user,
                      commentItem,
                      commentIndex
                    )}
                  >
                    <i className="fal fa-at" title="Tag"></i>
                  </div>
                ) : null}

                {commentItem.attachments && commentItem.attachments.length ? (
                  <i
                    className="fal fa-paperclip attachment-icon"
                    title="Attachment"
                  ></i>
                ) : null}
              </div>
              <div className="post-reat-new">
                <div className="post-reat-head">
                  <div className="post-reat-icon">
                    <button
                      className="feed-reaction-button"
                      title="Like"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 1,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={ThumbsUpIcon} alt="Like" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Dislike"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 2,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={ThumbsDownIcon} alt="Dislike" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Love"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 3,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={RedHeartIcon} alt="Love" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Laugh"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 4,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={GrinningIcon} alt="Laugh" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Surprised"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 5,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={OpenFaceIcon} alt="Surprised" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Sad"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 6,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={FrowningIcon} alt="Sad" />
                    </button>
                    <button
                      className="feed-reaction-button"
                      title="Angry"
                      onClick={() => {
                        props.likeDislikeHandle({
                          comment_id: commentItem.id,
                          table_type: "comment",
                          comment_type: 7,
                          message_id: commentItem.message_id,
                        });
                      }}
                    >
                      <img className="chat-reaction-icon" src={PoutingIcon} alt="Angry" />
                    </button>
                  </div>
                  <div className="post-reat-action">
                    <a
                      className="feed-reaction-button"
                      onClick={() => handleReplyToComment(commentItem)}
                      title="Reply"
                      href={`#reply-input-editor-${props?.message_id}`}
                    >
                      <i className="far fa-reply-all"></i>
                    </a>
                    {props?.user?.id == commentItem?.user?.id ? (
                      <>
                        <button
                          className="feed-reaction-button"
                          onClick={() => editComment(commentItem)}
                          title="Edit"
                        >
                          <i className="far fa-edit"></i>
                        </button>
                        <button
                          className="feed-reaction-button"
                          onClick={() => deleteConfirm(commentItem.id)}
                          title="Delete"
                        >
                          <i className="far fa-trash-alt"></i>                        
                        </button>
                      </>
                    ) : null}
                  </div>
                  <div className="post-reat-more">
                    <a href="#!" title="More">
                      <i
                        className="fas fa-ellipsis-h"
                        onClick={() => {
                          props.setShowHideCOmm(
                            props.showHideCOmm ? "" : commentItem.id
                          );
                        }}
                      ></i>
                    </a>
                  </div>
                </div>
                <div
                  className={`post-reat-list ${
                    props.showHideCOmm == commentItem.id ? "" : " d-none"
                  }`}
                >
                  <h4>
                    Reactions (
                    {(commentItem && commentItem.likes && commentItem.likes.length
                      ? commentItem.likes.length
                      : 0) +
                      (commentItem && commentItem.dislikes && commentItem.dislikes.length
                        ? commentItem.dislikes.length
                        : 0) +
                      (commentItem && commentItem.love && commentItem.love.length
                        ? commentItem.love.length
                        : 0) +
                      (commentItem && commentItem.laugh && commentItem.laugh.length
                        ? commentItem.laugh.length
                        : 0) +
                      (commentItem && commentItem.surprised && commentItem.surprised.length
                        ? commentItem.surprised.length
                        : 0) +
                      (commentItem && commentItem.sad && commentItem.sad.length
                        ? commentItem.sad.length
                        : 0) +
                      (commentItem && commentItem.angry && commentItem.angry.length
                        ? commentItem.angry.length
                        : 0)}
                    )
                  </h4>
                  <ul>
                    {renderActionList(commentItem.likes, commentIndex)}
                    {renderActionList(commentItem.dislikes, commentIndex)}
                    {renderActionList(commentItem.love, commentIndex)}
                    {renderActionList(commentItem.laugh, commentIndex)}
                    {renderActionList(commentItem.surprised, commentIndex)}
                    {renderActionList(commentItem.sad, commentIndex)}
                    {renderActionList(commentItem.angry, commentIndex)}
                  </ul>
                </div>
              </div>
              <div className="card-left assigned-title-blk">
                <div className="card-left-by-img online-status user-drop-down-img">
                  {(commentItem.user && commentItem.user.photo) || (commentItem.adminuser && commentItem.adminuser.photo) ? (
                    <img
                      src={
                        commentItem.user && commentItem.user.photo
                          ? commentItem.user.photo
                          : commentItem.adminuser && commentItem.adminuser.photo
                          ? commentItem.adminuser.photo
                          : null
                      }
                      alt={
                        commentItem?.user?.fullname ||
                        commentItem?.adminuser?.fullname ||
                        null
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.closest('.card-left-by-img').append(InitalRender(originalValues(commentItem.user ? commentItem.user.fullname : (commentItem.adminuser ? commentItem?.adminuser?.fullname : "") , 23)));
                        currentTarget.remove();
                      }} 
                    />
                  ) : (
                    commentItem?.user?.fullname ? InitalRender(commentItem?.user?.fullname, 23) : <img src={UnknownStudent} alt="Unknown User" />
                  )}
                  {commentItem.user ? 
                    <span
                      className={
                        `portal-status-icon ${
                          commentItem.user?.activity_status?.toLowerCase() == "online"
                            ? "online-u"
                            : commentItem.user?.activity_status?.toLowerCase() ==
                              "donotdisturb"
                            ? "donotdisturb-u"
                            : "offline-u"
                        }`
                      }
                    >
                      {" "}
                    </span>
                  : 
                    <span
                      className={`portal-status-icon border-0`
                      }
                    >
                      <img src={UnknownStudentStatus} alt="unknown" />
                    </span>
                  }
                </div>
                <UserHover
                  user={commentItem.user}
                  hideEmail={true}
                  online={`portal-status-icon ${
                    commentItem.user?.activity_status?.toLowerCase() == "online"
                      ? "online-u"
                      : commentItem.user?.activity_status?.toLowerCase() ==
                        "donotdisturb"
                      ? "donotdisturb-u"
                      : "offline-u"
                  }`}
                />
              </div>
              <div className="card-right">
                <div className="d-flex justify-content-between">
                  <h5 className="comment-con">
                    <div className="profile-title-box-main">
                      <div className="profile-title-box">
                        <a href="#">{commentItem.user?.fullname ? commentItem.user.fullname : "Unknown User" }</a>
                        <span className="post-by-time">
                          {moment(
                            commentItem?.created_at,
                            "Do MMMM YYYY, h:mm:ss a"
                          ).format("dddd") +
                            ", " +
                            moment(
                              commentItem?.created_at,
                              "Do MMMM YYYY, h:mm:ss a"
                            ).format(Str.TABLE_DATE_TIME_FORMAT)}
                        </span>
                        <small>
                          {commentItem.roleKey ? rollsWidget(commentItem.roleKey) : ""}
                        </small>
                      </div>                        

                      <div className="main-thums-mob mob-profile-right">   
                        <div className="d-flex align-items-center">
                          <div className="mob-profile-dotted">
                            <i className="fas fa-ellipsis-v"></i>
                          </div>                     
                        </div>
                        <div className="tag-point-list">
                          <div className="row_icons_fas ls_box mob-discuss-icons  mob-post-static">
                            {commentItem.important ? (
                              <i
                                className="fal fa-exclamation important-icon"
                                title="Important"
                              ></i>
                            ) : null}
                            {showTagIcon(
                              commentItem.comment,
                              commentItem.user_id,
                              props.user.id,
                              props.user,
                              commentItem,
                              commentIndex
                            ) != "" ? (
                              <div
                                className={showTagIcon(
                                  commentItem.comment,
                                  commentItem.user_id,
                                  props.user.id,
                                  props.user,
                                  commentItem,
                                  commentIndex
                                )}
                              >
                                <i className="fal fa-at" title="Tag"></i>
                              </div>
                            ) : null}

                            {commentItem.attachments && commentItem.attachments.length ? (
                              <i
                                className="fal fa-paperclip attachment-icon"
                                title="Attachment"
                              ></i>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </h5>
                </div>                
                <HtmlInputEditorShowComment
                  data={commentItem.comment}
                  tagClassName={userTagColor(commentItem.user_id, props.user.id)}
                  setCurrentVideo={props.setCurrentVideo}
                  editableArr={props.showHideEditArr}
                  allData={commentItem}
                  sendClick={sendClickHandle}
                  importantArr={importantArr}
                  setIsImportant={importantHandle}
                  isImportant={commentItem.important}
                  removeEditableId={removeEditableId}
                  userData={props.userData}
                  deletedFileHandle={deletedFileHandle}
                />
                <div className="chat-reaction-bar">
                  {commentItem?.likes?.length ? (
                    <button className={"chat-message-reaction " + (isLiked(user.id, commentItem.likes ? commentItem.likes : []) ? "active" : "")} title="Like" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 1,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={ThumbsUpIcon} alt="Like" /> <span>{commentItem.likes?.length}</span>
                    </button>
                  ) : null}
                  {commentItem?.dislikes?.length ? (
                    <button className={"chat-message-reaction " + (isDisliked(user.id, commentItem.dislikes ? commentItem.dislikes : []) ? "active" : "")} title="Dislike" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 2,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={ThumbsDownIcon} alt="Dislike" /> <span>{commentItem.dislikes?.length}</span>
                    </button>
                  ) : null}
                  {commentItem?.love?.length ? (
                    <button className={"chat-message-reaction " + (isDisliked(user.id, commentItem.love ? commentItem.love : []) ? "active" : "")} title="Love" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 3,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={RedHeartIcon} alt="Love" /> <span>{commentItem.love?.length}</span>
                    </button>
                  ) : null} 
                  {commentItem?.laugh?.length ? (
                    <button className={"chat-message-reaction " + (isLaughed(user.id, commentItem.laugh ? commentItem.laugh : []) ? "active" : "")} title="Laugh" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 4,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={GrinningIcon} alt="Laugh" /> <span>{commentItem.laugh?.length}</span>
                    </button>
                  ) : null}
                  {commentItem?.surprised?.length ? (
                    <button className={"chat-message-reaction " + (isSurprised(user.id, commentItem.surprised ? commentItem.surprised : []) ? "active" : "")} title="Surprised" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 5,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={OpenFaceIcon} alt="Surprised" /> <span>{commentItem.surprised?.length}</span>
                    </button>
                  ) : null}
                  {commentItem?.sad?.length ? (
                    <button className={"chat-message-reaction " + (isSad(user.id, commentItem.sad ? commentItem.sad : []) ? "active" : "")} title="Sad" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 6,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={FrowningIcon} alt="Sad" /> <span>{commentItem.sad?.length}</span>
                    </button>
                  ) : null} 
                  {commentItem?.angry?.length ? (
                    <button className={"chat-message-reaction " + (isSad(user.id, commentItem.angry ? commentItem.angry : []) ? "active" : "")} title="Angry" onClick={() => {
                      props.likeDislikeHandle({
                        comment_id: commentItem.id,
                        table_type: "comment",
                        comment_type: 7,
                        message_id: commentItem.message_id,
                      });
                    }}>
                        <img className="chat-reaction-icon" src={PoutingIcon} alt="Angry" /> <span>{commentItem.angry?.length}</span>
                    </button>
                  ) : null}                      
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
export default React.memo(FeedComments);
